import {useEffect} from 'react'

export default (id, addContractorsTab, onclose) => {

    useEffect(() => {
        window.addEventListener("message", receiveMessage, false);
        return () => {
            window.removeEventListener("message", receiveMessage)
        };
        // eslint-disable-next-line
    }, [])

    function receiveMessage(event) {
        if (event.data.action && (typeof event.data.action === 'string' || event.data.action instanceof String)) {
            if (event.data.action === "refreshSuppliers") addContractorsTab(event.data)
        }
        if (event.data.action === "closeSupplierSearch") closeSupplierSearch()
    }


    function closeSupplierSearch() {
        onclose();
    }

}

